import React from 'react'

export function ConsultancyBlurb() {
  return <div className="p-3 mb-3 bg-light rounded">
    <h4 className="font-italic">About</h4>
    <p className="mb-0">Browntree Labs is a consultancy that helps businesses solve complex problems. We mostly operate
      in New York. But we can work <span className="highlight">globally</span></p>
  </div>
}